var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (ngRequired, required) {pug_mixins["centered-content"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "centered-content","layout": "row"},attributes]), true)) + "\u003E\u003Cdiv class=\"content\" layout=\"column\" layout-align=\"start stretch\" flex flex-md=\"90\" flex-lg=\"80\" flex-gt-lg=\"70\" flex-offset-md=\"5\" flex-offset-lg=\"10\" flex-offset-gt-lg=\"15\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["contentful-component"] = pug_interp = function(component){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-if", "" + component + ".fields.type === 'wide'", true, true)) + "\u003E\u003Cicon-panel" + (" class=\"wide-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E\u003C\u002Fdiv\u003E";
pug_mixins["centered-content"].call({
block: function(){
pug_html = pug_html + "\u003Cicon-panel" + (" class=\"standard-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E";
},
attributes: {"ng-if": pug.escape("" + component + ".fields.type !== 'wide'")}
});
};





























pug_mixins["required-radio-container"] = pug_interp = function(name, model, layout){
var block = (this && this.block), attributes = (this && this.attributes) || {};
ngRequired = attributes['ng-required']
required = !ngRequired
layout = layout || 'row'
pug_html = pug_html + "\u003Cmd-radio-group" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("ng-model", model, true, true)+pug.attr("layout", layout, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003Chelp-mate" + (pug.attr("topic", name, true, true)) + "\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fmd-radio-group\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("required", required, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E";
};








pug_mixins["required-select"] = pug_interp = function(name, model, label){
var block = (this && this.block), attributes = (this && this.attributes) || {};
label = label || name
pug_html = pug_html + "\u003Cinput-container" + (pug.attr("label", label, true, true)) + "\u003E\u003Cmd-select" + (" class=\"required-select big-list\""+pug.attr("ng-model", model, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)+pug.attr("placeholder", label, true, true)+pug.attr("aria-label", label, true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fmd-select\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("required", true, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E\u003C\u002Finput-container\u003E";
};










































































pug_mixins["rateDisplay"] = pug_interp = function(rate){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + (pug.escape(null == (pug_interp = rate) ? "" : pug_interp)) + "\u003Cimg src=\"\u002Ficons\u002Ficon-percent-pa.svg\" alt=\"percentage pa\"\u003E";
};












pug_html = pug_html + "\u003Cdiv class=\"md-padding\"\u003E\u003Chelp-box heading=\"Your loan investments\"\u003E\u003Cp\u003EBelow is a list of all your investments. Click on an investment to see further details or to select for listing any you may want to exit.  \u003C\u002Fp\u003E\u003Cp\u003EIf you choose to list an investment, we offer that amount to other investors in the \u003Ctenant-inline element-id=\"name.short\"\u003E\u003C\u002Ftenant-inline\u003E P2P Marketplace. \nOnce purchased, the listed amount (less a 0.5% conversion fee) will be credited to the balance of your Available Funds.\n\u003C\u002Fp\u003E\u003C\u002Fhelp-box\u003E\u003Cmd-table-container\u003E\u003Ctable md-table md-progress=\"vm.loading\"\u003E\u003Cthead md-head md-order=\"vm.order\"\u003E\u003Ctr md-row\u003E\u003Cth class=\"reference\" md-column md-order-by=\"loanPart.loanRequestSummary.reference + '.' + loanPart.id\"\u003ELoan reference\u003C\u002Fth\u003E\u003Cth class=\"rate\" md-column md-numeric md-order-by=\"loanPart.rate * 1.0 - loanPart.marginRate * 1.0\"\u003EInvestor rate\u003Chelp-mate topic=\"investor-rate\"\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fth\u003E\u003Cth class=\"capital-outstanding\" if-media-size=\"gt-xs\" md-column md-numeric md-order-by=\"loanPart.capitalOutstanding * 1.0\"\u003ECapital outstanding\u003C\u002Fth\u003E\u003Cth class=\"payments-remaining\" if-media-size=\"gt-xs\" md-column md-numeric md-order-by=\"loanPart.paymentsRemaining * 1.0\"\u003ERemaining payments\u003C\u002Fth\u003E\u003Cth class=\"next-payment-date with-help\" md-column md-numeric md-order-by=\"loanPart.nextRepaymentSummary.expectedDate\"\u003ENext payment\u003Chelp-mate topic=\"next-payment-date\"\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fth\u003E\u003Cth class=\"next-payment-amount\" md-column md-numeric md-order-by=\"loanPart.nextRepaymentSummary.amount * 1.0\"\u003EPayment amount\u003C\u002Fth\u003E\u003Cth class=\"loan-status\" if-media-size=\"gt-md\" md-column md-numeric md-order-by=\"loanPartStatus\"\u003ELoan status\u003Chelp-mate topic=\"loan-status\"\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fth\u003E\u003Cth class=\"redeem\" md-column\u003E\u003C\u002Fth\u003E\u003C\u002Ftr\u003E\u003C\u002Fthead\u003E\u003Ctbody md-body ng-if=\"vm.compositeLoanParts.length &gt; 0\"\u003E\u003Ctr class=\"loan-part\" md-row ng-click=\"vm.toggleRedeemRow(compositeLoanPart.loanPart.id)\" ng-class=\"{'is-open': vm.displayRedeemRow(compositeLoanPart.loanPart.id), 'cy-listable': vm.loanPartsAvailableForList(compositeLoanPart)}\" ng-repeat-start=\"compositeLoanPart in vm.compositeLoanParts | orderBy : vm.order | limitTo: vm.limit: (vm.page - 1) * vm.limit\"\u003E\u003Ctd class=\"reference\" md-cell\u003E\u003Ca ui-sref=\"loanRequestDetails({id: compositeLoanPart.loanPart.loanRequestId})\" ng-class=\"vm.convertToClass(compositeLoanPart.loanPartStatus)\"\u003E{{ compositeLoanPart.loanPart.loanRequestSummary.reference + '.' + compositeLoanPart.loanPart.id }}\u003C\u002Fa\u003E\u003C\u002Ftd\u003E\u003Ctd class=\"rate\" md-cell\u003E{{ compositeLoanPart.loanPart.rate - compositeLoanPart.loanPart.marginRate | number : 1 }}%\u003C\u002Ftd\u003E\u003Ctd class=\"capital-outstanding\" if-media-size=\"gt-xs\" md-cell\u003E{{ compositeLoanPart.loanPart.capitalOutstanding | asCurrency }}\u003C\u002Ftd\u003E\u003Ctd class=\"payments-remaining\" if-media-size=\"gt-xs\" md-cell\u003E{{ compositeLoanPart.loanPart.paymentsRemaining }}\u003C\u002Ftd\u003E\u003Ctd class=\"next-payment-date\" md-cell\u003E{{ compositeLoanPart.loanPart.nextRepaymentSummary.expectedDate | date: 'd MMM yyyy' }}\u003C\u002Ftd\u003E\u003Ctd class=\"next-payment-amount\" md-cell\u003E{{ compositeLoanPart.loanPart.nextRepaymentSummary.amount | asCurrency }}\u003C\u002Ftd\u003E\u003Ctd class=\"loan-status\" if-media-size=\"gt-md\" md-cell\u003E\u003Ca ui-sref=\"loanRequestDetails.loanHistory({id: compositeLoanPart.loanPart.loanRequestId})\" ng-class=\"vm.convertToClass(compositeLoanPart.loanPartStatus)\"\u003E{{ compositeLoanPart.loanPartStatusDisplay }}\u003C\u002Fa\u003E\u003C\u002Ftd\u003E\u003Ctd class=\"redeem\" md-cell\u003E\u003Cmd-icon aria-label=\"show detail\" ng-if=\"!vm.displayRedeemRow(compositeLoanPart.loanPart.id)\"\u003E{{vm.listingsControlIcon(compositeLoanPart)}}\u003C\u002Fmd-icon\u003E\u003Cmd-icon aria-label=\"hide detail\" ng-if=\"vm.displayRedeemRow(compositeLoanPart.loanPart.id)\"\u003E{{vm.listingsControlIcon(compositeLoanPart)}}\u003C\u002Fmd-icon\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr class=\"details\" md-row ng-repeat-end ng-if=\"vm.displayRedeemRow(compositeLoanPart.loanPart.id)\"\u003E\u003Ctd md-cell colspan=\"8\"\u003E \u003Cloan-part-details composite-loan-part=\"compositeLoanPart\"\u003E\u003C\u002Floan-part-details\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftbody\u003E\u003Ctbody class=\"no-entries\" md-body ng-if=\"vm.compositeLoanParts.length == 0\"\u003E\u003Ctr md-row\u003E\u003Ctd md-cell colspan=\"8\"\u003ENo units found.\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftbody\u003E\u003C\u002Ftable\u003E\u003Cmd-table-pagination ng-if=\"vm.compositeLoanParts.length &gt; 0\" md-total=\"{{vm.compositeLoanParts.length}}\" md-limit-options=\"vm.limitOptions\" md-limit=\"vm.limit\" md-page=\"vm.page\"\u003E\u003C\u002Fmd-table-pagination\u003E\u003C\u002Fmd-table-container\u003E\u003C\u002Fdiv\u003E";}.call(this,"ngRequired" in locals_for_with?locals_for_with.ngRequired:typeof ngRequired!=="undefined"?ngRequired:undefined,"required" in locals_for_with?locals_for_with.required:typeof required!=="undefined"?required:undefined));;return pug_html;};
module.exports = template;